import { render, staticRenderFns } from "./UpskillCoursesDetails.vue?vue&type=template&id=02be4aad&scoped=true"
import script from "./UpskillCoursesDetails.vue?vue&type=script&lang=ts"
export * from "./UpskillCoursesDetails.vue?vue&type=script&lang=ts"
import style0 from "./UpskillCoursesDetails.vue?vue&type=style&index=0&id=02be4aad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02be4aad",
  null
  
)

export default component.exports